import gql from "graphql-tag";
import { IImagePreview } from "../gallery.js";
import { imagePreview } from "../fragments.js";
import { Game, GameContent, gamePreview } from "./_common.js";

export interface Quiz extends Game<QuizContent> {
    __typename: "Quiz";
    questionsNumber: number;
    avgScore: number | null;
}

export interface QuizContent extends GameContent {
    nextQuestionButton: string;
    showResultButton: string;
    restartButton: string;
    shareMessage: string;
    shareYourResult: string | null;
    questions: QuizQuestionContent[];
    summaries: QuizSummaryContent[];
}

export interface QuizQuestionContent {
    id: string;
    text: string;
    answerImage: IImagePreview | null;
    image: IImagePreview | null;
    answerComment: string | null;
    variants: QuizVariantContent[];
}

export interface QuizVariantContent {
    id: string;
    text: string;
    answerComment: string | null;
    isCorrect: boolean;
    pickedCount: number | null;
}

export interface QuizSummaryContent {
    title: string;
    text: string;
    minCorrect: number;
    image: IImagePreview | null;
}

export const GET_QUIZ = gql`
    query getQuiz($langCode: LangCode, $id: QuizID!) {
        game: quiz(id: $id) {
            id
            slug
            date
            updatedAt
            featured
            contentLangs
            usersCount
            questionsNumber
            avgScore
            content(langCode: $langCode) {
                title
                metaTitle
                keywords
                text
                metaDescription
                image {
                    ...imagePreview
                }
                startButton
                nextQuestionButton
                showResultButton
                restartButton
                shareMessage
                shareYourResult
                questions {
                    id
                    text
                    answerComment
                    answerImage {
                        ...imagePreview
                    }
                    image {
                        ...imagePreview
                    }
                    variants {
                        id
                        text
                        answerComment
                        isCorrect
                        pickedCount
                    }
                }
                summaries {
                    title
                    text
                    minCorrect
                    image {
                        ...imagePreview
                    }
                }
            }
            recommendedGames {
                ...gamePreview
            }
            promoApps(platforms: [ios, android, huawei]) {
                id
                title
                icon {
                    sourceUrl
                    sizes
                }
                marketUrl
                marketId
                platform
            }
            engagementInfo {
                facebook
                messenger
                twitter
                telegram
                whatsapp
                native
            }
            topics {
                id
                content(langCode: $langCode) {
                    title
                }
            }
        }
    }
    ${imagePreview}
    ${gamePreview}
`;

export const PICK_QUIZ_QUESTION_VARIANT = gql`
    mutation pickQuizQuestionVariant($input: PickQuizQuestionVariantInput!) {
        pickQuizQuestionVariant(input: $input) {
            picked
        }
    }
`;

export type VoteValue = "LIKE" | "DISLIKE";

export interface VoteQuizQuestionVariables {
    input: {
        quizId: string;
        questionId: string;
        voteValue: VoteValue;
    };
}

export const VOTE_QUIZ_QUESTION = gql`
    mutation voteQuizQuestion($input: VoteQuizQuestionInput!) {
        voteQuizQuestion(input: $input) {
            voted
        }
    }
`;

export const SAVE_QUIZ_RESULT = gql`
    mutation saveQuizResult($input: SaveQuizResultInput!) {
        saveQuizResult(input: $input) {
            saved
        }
    }
`;
